import { Point } from './Point.js'
import { GEObject } from './GEObject.js'

export class AddPointTool extends GEObject {
	point
	onchange
	isActive = false
	properties = {}
	constructor(editor) {
		super()
		this.editor = editor
		this.editor.canvas.addEventListener('mousedown',this.mousedown.bind(this))
	}
	activate(properties) {
		this.properties = properties
		this.isActive = true
		this.trigger('isActive', this.isActive, properties)
	}
	deactivate() {
		this.isActive = false
		this.properties = null
		this.trigger('isActive', this.isActive)
	}
	mousedown(event) {
		if(!this.isActive) {
			return
		}
		if(this.point) {
			return
		}
		let x = event.offsetX * this.editor.getPixelRatio()
		let y = event.offsetY * this.editor.getPixelRatio()
		let point = new Point(x, y, this.properties)
		point.setSelected(true)
		this.trigger('add', point)
	}
}